import { render, staticRenderFns } from "./feednews.vue?vue&type=template&id=252bfd50&lang=true&"
import script from "./feednews.vue?vue&type=script&lang=js&"
export * from "./feednews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports